// extracted by mini-css-extract-plugin
module.exports = {"loadingAnimation":"Loader_loadingAnimation__LSt-j","normal":"Loader_normal__3_EL2","loading-animation":"Loader_loading-animation__22KrX","small":"Loader_small__2LEeU"};